import { useState } from 'react'
import { Button } from "@/components/ui/button"
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card"
import type { QuizQuestion } from "@/types/quiz"

interface QuizCardProps {
  question: QuizQuestion
  onSelect: (traits: string[]) => void
}

export function QuizCard({ question, onSelect }: QuizCardProps) {
  const [selected, setSelected] = useState<string | null>(null)

  const handleSelect = (optionIndex: number) => {
    setSelected(question.options[optionIndex].value)
    // Format traits with category for better organization
    const traits = question.options[optionIndex].traits.map(
      trait => `${question.category}:${trait}`
    )
    onSelect(traits)
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle>{question.question}</CardTitle>
        <CardDescription>{question.description}</CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        {question.options.map((option) => (
          <Button
            key={`${question.id}-${option.id}`}
            variant={selected === option.value ? "default" : "outline"}
            className="w-full justify-start flex-col items-start p-4 h-auto gap-1"
            onClick={() => handleSelect(question.options.indexOf(option))}
          >
            <span className="font-semibold">{option.label}</span>
            <span className="text-sm text-muted-foreground text-left">
              {option.description}
            </span>
          </Button>
        ))}
      </CardContent>
    </Card>
  )
}